jQuery(document).ready(function ($) {
  //if ignore info is not set + bar_ip_country = SA => open Popup
  if (getIpCountryCookie() === "SA" && window.localStorage.getItem("show_popup_for_customer_location") !== "no") {
    $("#popup_for_customer_location").removeClass("hidden");
  }

  $("#close_popup_for_customer_location").on("click", function (e) {
    //close => save info that we ignore that!
    window.localStorage.setItem("show_popup_for_customer_location", "no");
    $("#popup_for_customer_location").addClass("hidden");
  });
});

function getIpCountryCookie() {
  const name = "bar_ip_country=";
  const cDecoded = decodeURIComponent(document.cookie); //to be careful
  const cArr = cDecoded.split("; ");
  let res;
  cArr.forEach((val) => {
    if (val.indexOf(name) === 0) res = val.substring(name.length);
  });
  return res;
}
